import isSpacedString from "@/helpers/isSpacedString";
import { Company } from "@/modules/companies/interfaces/company";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useCompanySearchStore = defineStore("companySearch", () => {
  const query = ref("");
  const companies = ref<Company[]>([]);

  return {
    query,
    companies,

    setQuery(value: string) {
      if (!isSpacedString(value)) {
        query.value = value;
      }
    },
    setCompanies(value: Company[]) {
      companies.value = value;
    },
    resetState() {
      query.value = "";
      companies.value = [];
    },
  };
});
